// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--AlQ-H";
export var review = "footer-module--review--XA8II";
export var reviewLabel = "footer-module--reviewLabel--1YTgA";
export var reviewLink = "footer-module--reviewLink--QcUfP";
export var reviewLinkWrapper = "footer-module--reviewLinkWrapper--W-MOq";
export var socials = "footer-module--socials--OuK7z";
export var socialsLinks = "footer-module--socialsLinks--307jy";
export var socialsTitle = "footer-module--socialsTitle--9QAcq";